import i18n from 'modules/core/lib/i18n'

export const formatPercentage = (value: number | null | undefined, placeholder = '-') => {
  if (value == null || Number.isNaN(value)) return placeholder

  const roundedRatio = Math.round(value * 10_000) / 10_000

  return i18n.formatNumber(roundedRatio, 'percent')
}
